/* @flow */

const getFormularioPorId = (id: string): HTMLFormElement => {
    const form = document.getElementById(id);

    if (!form) {
        throw new TypeError(`${id} não econtrado no documento`);
    }

    if (form instanceof HTMLFormElement) {
        return form;
    }

    throw new TypeError(`#${id} não é um formulario.`);
};

export default getFormularioPorId;
